var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-indicator"},[_c('f7-preloader',{attrs:{"color":"white","size":28}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }